import {createApp} from 'vue'
import CreateStafetProfile from './CreateStafetProfile'

const el = '.kb-component--create-stafet-profile'

export default function(Store){
    const DOM = document.querySelectorAll(el)
    if(DOM.length){
        DOM.forEach((CreateStafetProfileDOM)=>{

            const props = {
                userProfileId: CreateStafetProfileDOM.dataset.userProfileId ?? null,
                email: CreateStafetProfileDOM.dataset.email ?? null,
                firstName: CreateStafetProfileDOM.dataset.firstName ?? null,
                lastName: CreateStafetProfileDOM.dataset.lastName ?? null,
                phone: CreateStafetProfileDOM.dataset.phone ?? null,
                informationRichText: CreateStafetProfileDOM.dataset.informationRichText ?? null,
            }

            const component = createApp(CreateStafetProfile, props).use(Store)
            component.mount(CreateStafetProfileDOM)
        })
    }
}